"use strict";

exports.__esModule = true;
exports.default = actHack;

function actHack(callback) {
  callback();
}


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-apollo-hooks/lib/internal/actHack.js
// module id = 227
// module chunks = 178331994103267 231608221292675